import React, { useState } from 'react';
import { Box, List, ListItem, Stack, Modal, useMediaQuery, Link } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Circle } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import styles from './styles';

const EirInsuranceModal = ({
  openInsuranceModal,
  handleClose,
  disableCloseOnBackdropClick,
  disableCloseOnEscapeKeyDown,
  InsuranceHeading,
  InsuranceList,
}) => {
  const [expanded, setExpanded] = useState(false);
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.down('sm'));
  const handleChange = panel => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  const handleDefaultClose = (event, reason) => {
    if (
      !(
        (reason === 'backdropClick' && disableCloseOnBackdropClick === true) ||
        (reason === 'escapeKeyDown' && disableCloseOnEscapeKeyDown === true)
      )
    ) {
      handleClose();
    }
  };

  const hasLink = description => {
    const regex = /<a\b[^>]*>/i;
    return regex.test(description);
  };

  return (
    <Modal
      open={openInsuranceModal}
      onClose={handleDefaultClose}
      sx={styles(theme).InsuranceModalRoot}
    >
      <Box style={styles(theme).mainContainerBox}>
        <Box sx={styles(theme).mainHeadingBox}>
          <Stack direction='row' justifyContent='space-between' alignItems='center'>
            <Typography variant='h4' component='h4' sx={styles(theme).mainHeading}>
              {InsuranceHeading}
            </Typography>
            <CloseIcon
              onClick={() => {
                handleClose();
              }}
              sx={styles(theme).closeIcon}
            />
          </Stack>
        </Box>

        {InsuranceList?.map((list, i) => (
          <Accordion
            disableGutters
            square
            key={i}
            expanded={expanded === `${list.Title}`}
            onChange={handleChange(`${list.Title}`)}
            sx={styles(theme).accordMain}
          >
            <AccordionSummary
              expandIcon={
                <ExpandMoreIcon
                  sx={{ color: theme.palette.secondary.errorCTA, paddingRight: '4px' }}
                />
              }
              sx={{ ...styles(theme).accordSummaryMain, p: sm ? '0px 8px 0px 0px' : '' }}
            >
              <Typography variant='subtitle2' sx={styles(theme).accordSummaryTitle}>
                {list.Title}
              </Typography>
            </AccordionSummary>

            <AccordionDetails sx={{ padding: sm ? '0.75rem 0 0 0' : 0 }}>
              {list.Description?.length > 0 && (
                <List sx={{ padding: sm ? '0px 22px 25px 8px' : '0px 33px 25px 38px' }}>
                  {list.Description.map(description => (
                    <ListItem key={description.id} sx={{ padding: '0px 0px 0px 9px' }}>
                      <Stack direction='row' sx={{ width: '100%' }}>
                        <Circle
                          sx={{
                            height: 4,
                            width: 4,
                            mt: '8.5px',
                            color: theme.palette.primary.offerMain,
                          }}
                        />
                        {hasLink(description.Description) ? (
                          <Typography variant='body2' sx={{ pl: 1 }}>
                            {description.Description.substring(
                              0,
                              description.Description.indexOf('<a')
                            )}
                            <Link
                              href={description.Description.match(/href="([^"]+)"/)[1]}
                              target='_blank'
                              rel='noopener noreferrer'
                              sx={{ color: theme.palette.secondary.errorCTA }}
                            >
                              {description.Description.match(/<a[^>]*>([^<]+)<\/a>/)[1]}
                            </Link>
                            {description.Description.substring(
                              description.Description.indexOf('</a>') + 4
                            )}
                          </Typography>
                        ) : (
                          <Typography variant='body2' sx={{ pl: 1 }}>
                            {description.Description}
                          </Typography>
                        )}
                      </Stack>
                    </ListItem>
                  ))}
                </List>
              )}
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>
    </Modal>
  );
};

export default EirInsuranceModal;
